// extracted by mini-css-extract-plugin
export var blue = "_1v-h";
export var brand = "_1v-d";
export var darkGrey = "_1v-g";
export var disabled = "_1v-6";
export var disabledSubtle = "_1v-7";
export var error = "_1v-8";
export var green = "_1v-i";
export var grey = "_1v-f";
export var icon = "_1v-0";
export var inherit = "_1v-c";
export var lightGrey = "_1v-e";
export var orange = "_1v-k";
export var pink = "_1v-m";
export var primary = "_1v-1";
export var purple = "_1v-n";
export var quaternary = "_1v-4";
export var quinary = "_1v-5";
export var red = "_1v-l";
export var secondary = "_1v-2";
export var success = "_1v-b";
export var tertiary = "_1v-3";
export var warning = "_1v-9";
export var warningSecondary = "_1v-a";
export var white = "_1v-o";
export var yellow = "_1v-j";